/* @flow weak */
import Button from 'components/Button.jsx';
import Buttons from 'components/Buttons.jsx';
import Container from 'components/Container.jsx';
import ChangeUntrustedNameModal from 'chat/components/ChangeUntrustedNameModal.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import * as React from 'react';
import RelationshipActions from 'actions/RelationshipActions';
import Subscriber from 'entities/Subscriber';

class RelationshipViewUntrustedName extends React.Component<{ subscriber: Subscriber }> {
  handleConfirmSubscriberName = event => {
    event.preventDefault();
    RelationshipActions.confirmUntrustedName(this.props.subscriber.id);
  };

  render() {
    const { subscriber } = this.props;

    if (!subscriber.getUntrustedName()) {
      return null;
    }

    // $FlowFixMe the modal requires onRequestHide, which isn't supplied until ModalTrigger
    const changeUntrustedNameModal = <ChangeUntrustedNameModal subscriber={subscriber} />;

    return (
      <div className="RelationshipView-untrustedName">
        <h3 className="RelationshipView-untrustedName-title">Is this person’s name correct?</h3>
        <Container size="xxsmall">
          <Buttons full>
            <Button
              level="primary"
              size="xsmall"
              color="brand"
              onClick={this.handleConfirmSubscriberName}>
              Yes
            </Button>
            <ModalTrigger modal={changeUntrustedNameModal}>
              <Button level="primary" size="xsmall" color="brand">
                No
              </Button>
            </ModalTrigger>
          </Buttons>
        </Container>
      </div>
    );
  }
}
export default RelationshipViewUntrustedName;
